import React from "react";
import * as cookie from "js-cookie";
import objectIsEmpty from '../../../design-system/utils/objectIsEmpty';
import { clearStoragePreservingAuth } from '../../../config/msalInstance';

export const SESSION_COOKIE = "session";
export const TMP_LOGIN_START_COOKIE = "TMP_LOGIN_START";

const USER_ROLES_KEY = 'userRoles';

export const setSessionCookie = (session) => {
    const rolesFromSplitLogin = localStorage.getItem(USER_ROLES_KEY);
    console.log('[roles-flow] 4.Session setSessionCookie → userRoles antes de clear:', rolesFromSplitLogin != null ? 'existe (' + (rolesFromSplitLogin?.length ?? 0) + ' chars)' : 'null');
    // Limpia storage preservando la cache de MSAL (refresh token), userRoles y
    // el ID token stashed. Preservar MSAL permite que acquireTokenSilent renueve
    // el ID token al expirar (~1h) sin re-login; antes el clear total borraba el
    // refresh token y la auth se perdía pasada la hora.
    clearStoragePreservingAuth();
    if (rolesFromSplitLogin != null) {
        console.log('[roles-flow] 5.Session userRoles preservado en localStorage');
    } else {
        console.log('[roles-flow] 5.Session userRoles NO existía → no se restaura (se pierde aquí si SplitLogin no guardó antes)');
    }
    Object.keys(cookie.get()).filter(_cookie => !_cookie.startsWith('talisis_ia_')).map(_cookie => cookie.remove(_cookie));
    
    // Set session cookie. Bi-directional login in subdomains.
    if ((window.location.host).includes(".talisis.com")) {
        cookie.set(SESSION_COOKIE, JSON.stringify(session), { domain: ".talisis.com" });
        if (!session["ignore_admin_talisis_cookie"]) {
            cookie.set("LOGIN_ADMIN_TALISIS", true, { domain: ".talisis.com" });
        }
    }
    else {
        cookie.set(SESSION_COOKIE, JSON.stringify(session));
        if (!session["ignore_admin_talisis_cookie"]) {
            cookie.set("LOGIN_ADMIN_TALISIS", true);
        }
    }

    localStorage.removeItem(SESSION_COOKIE);
    localStorage.setItem(SESSION_COOKIE, JSON.stringify(session));
};

export const getSessionCookie = () => {

    const sessionData = localStorage.getItem(SESSION_COOKIE);
    if (sessionData === undefined || sessionData === null) {
        return {};
    }
    else {
        return JSON.parse(sessionData);
    }
};

export const removeSessionCookie = (reload = false) => {
    if ((window.location.host).includes(".talisis.com")) {
        cookie.remove(SESSION_COOKIE, { domain: ".talisis.com" });
        cookie.remove("LOGIN_ADMIN_TALISIS", { domain: ".talisis.com" });
        cookie.remove("LOGIN_PLATFORM_TALISIS", { domain: ".talisis.com" });
    }
    else {
        cookie.remove(SESSION_COOKIE);
        cookie.remove("LOGIN_ADMIN_TALISIS");
        cookie.remove("LOGIN_PLATFORM_TALISIS");
    }

    // Logout: wipe everything, including the stashed B2C ID token. Unlike
    // setSessionCookie, we do NOT restore the token here — the user is leaving.
    localStorage.clear();
    sessionStorage.clear();
    if (reload) {
        window.location.reload();
    }
};

export const userIsLoggedIn = () => {
    const session = getSessionCookie();
    const isLogged = !objectIsEmpty(session);
    return isLogged;
};

export const SessionContext = React.createContext(getSessionCookie());

export const getCookie = (name) => cookie.get(name);
export const setCookie = (name, value) => cookie.set(name, String(value));
export const removeCookie = (name) => cookie.remove(name);